export default __webpack_public_path__ + "media/Number14.bca23c8cc6df58c935eb71fee353d632.mp4";